import mergeObjects from '@bybeam/platform-lib/answers/mergeObjects';
import {
  ApplicationQuestion,
  ApplicationSection,
  BaseDropdownItem,
  CommonQuestionKeys,
  ConfigOverrides,
  ExpressionType,
  FieldType,
  IntroPage,
  PaymentMethod,
  TextInputType,
} from '@bybeam/platform-types';
import { YesNoOptions } from '@platform-ui/application/utils/index.js';
import { eq, gte, literal, sum } from '../../ast/utils.js';
import STANDARD_COMPONENTS from '../standards/index.js';
import { SpecialSectionKeys } from '../standards/types.js';

const COURSES = [
  {
    course: 'ABC Focus - HCA Compliance Part 1 - Caring4Cal (Nevvon)',
    duration: 15,
    active: true,
  },
  {
    course: 'ABC Focus - HCA Compliance Part 2 - Caring4Cal (Nevvon)',
    duration: 15,
    active: true,
  },
  {
    course: 'ABC Focus - Mobility & Conditions Affecting Mobility - Caring4Cal',
    duration: 15,
    active: true,
  },
  {
    course: 'ABC Sacramento - Alta Regional C4C - Part 1 (Nevvon)',
    duration: 15,
    active: true,
  },
  {
    course: 'ABC Sacramento - Alta Regional / HCA C4C - Part 2 (Nevvon)',
    duration: 15,
    active: true,
  },
  {
    course: 'ABC Sacramento - HCA C4C - Part 1 (Nevvon)',
    duration: 15,
    active: true,
  },
  {
    course: 'ABC Sacramento - HCA C4C - Part 2 (Nevvon)',
    duration: 15,
    active: true,
  },
  {
    course: 'Abuse and Neglect Prevention',
    duration: 2,
    active: true,
  },
  {
    course: 'Abuse and Neglect Prevention and Reporting',
    duration: 2,
    active: true,
  },
  {
    course: 'Abuse, Neglect and Self-Care',
    duration: 6,
    active: true,
  },
  {
    course: 'AccentCare - Caring4Cal Part 1 (Nevvon)',
    duration: 15,
    active: true,
  },
  {
    course: 'AccentCare - Caring4Cal Part 2 (Nevvon)',
    duration: 15,
    active: true,
  },
  {
    course: 'Activities of Daily Living',
    duration: 2,
    active: true,
  },
  {
    course:
      'Adapting Evidence-Based and Informed Caregiver Interventions to Support Caregivers of People with Intellectual and Developmental Disabilities and Dementia',
    duration: 1.5,
    active: true,
  },
  {
    course:
      'Addressing Behavior Challenges in Individuals with Intellectual and Developmental Disabilities',
    duration: 2,
    active: true,
  },
  {
    course: 'Addressing Health Inequities',
    duration: 2,
    active: true,
  },
  {
    course: 'Advance Care Planning Cornerstone',
    duration: 8,
    active: true,
  },
  {
    course: 'Advanced Crisis Intervention Techniques',
    duration: 2,
    active: true,
  },
  {
    course: 'Advanced Healthy Aging Practices',
    duration: 2,
    active: true,
  },
  {
    course: 'Advanced Home Health Protocols',
    duration: 2,
    active: true,
  },
  {
    course: 'Advanced Home Health Techniques',
    duration: 2,
    active: true,
  },
  {
    course: 'Advanced Illness Care Program Stages',
    duration: 10,
    active: true,
  },
  {
    course: 'Advanced Legal & Ethical Considerations in Healthcare',
    duration: 2,
    active: true,
  },
  {
    course: 'Advanced Team Building for Healthcare',
    duration: 2,
    active: true,
  },
  {
    course: 'Advanced Training for Compassionate Caregivers',
    duration: 15,
    active: true,
  },
  {
    course: 'Advocacy and Systems Navigation for Home',
    duration: 5,
    active: true,
  },
  {
    course: 'Advocacy Skills',
    duration: 2,
    active: true,
  },
  {
    course: 'Aging & Disability Understanding',
    duration: 2,
    active: true,
  },
  {
    course:
      'Aging & Health Care Disparities in Individuals with Intellectual and Developmental Disabilities',
    duration: 1,
    active: true,
  },
  {
    course: 'Aging in Place: Developing Community Based Supports (Part 1)',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Aging in Place: Developing Community Based Supports (Part 2)',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Aging with Dignity',
    duration: 40,
    active: true,
  },
  {
    course: 'Akahina Home Care - Caring4Cal - Part 1 (Nevvon)',
    duration: 15,
    active: true,
  },
  {
    course: 'Akahina Home Care - Caring4Cal - Part 2 (Nevvon)',
    duration: 15,
    active: true,
  },
  {
    course: 'All about Corporate Compliance',
    duration: 1,
    active: true,
  },
  {
    course: "Alzheimer's & Dementia Care Training",
    duration: 2,
    active: true,
  },
  {
    course: 'Ambulation Simulation Debriefing(Gait Belt)',
    duration: 0.5,
    active: true,
  },
  {
    course: 'Ambulation Simulation(Gait Belt)',
    duration: 1,
    active: true,
  },
  {
    course: 'Asian American & Pacific (AAPI) Support',
    duration: 1,
    active: true,
  },
  {
    course: 'Asian American & Pacific Islander (AAPI) Lived Experiences',
    duration: 1,
    active: true,
  },
  {
    course: 'Asian American & Pacific Islander (AAPI) Support',
    duration: 1,
    active: true,
  },
  {
    course: 'Assisting with Medication Self-Administration',
    duration: 2,
    active: true,
  },
  {
    course: 'Assisting with Personal Care Through ADLs',
    duration: 2,
    active: true,
  },
  {
    course: 'Avoiding & Responding to Combative Behavior',
    duration: 0.58,
    active: true,
  },
  {
    course: 'Bailoterapia Circles-Instructor Training',
    duration: 24,
    active: true,
  },
  {
    course: 'Basic First Aide Tips',
    duration: 1,
    active: true,
  },
  {
    course: 'Basic Live Support by Fox Home Health Vocational Training',
    duration: 3,
    active: true,
  },
  {
    course: 'Basic nutrition and hydration',
    duration: 1,
    active: true,
  },
  {
    course: 'Battling Covid 19',
    duration: 1,
    active: true,
  },
  {
    course: 'Bed-to-Wheelchair Simulation',
    duration: 1,
    active: true,
  },
  {
    course: 'Bed-to-Wheelchair Simulation Debriefing',
    duration: 0.5,
    active: true,
  },
  {
    course: 'Bedpan Simulation',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Bedpan Simulation Debriefing',
    duration: 0.5,
    active: true,
  },
  {
    course: 'Beyond the bathtub / bathing alternatives',
    duration: 1,
    active: true,
  },
  {
    course: 'BHTS CNA-HHA Training Program',
    duration: 40,
    active: true,
  },
  {
    course: 'BHTS HHA-Only Training Program',
    duration: 40,
    active: true,
  },
  {
    course: 'Bill of Rights',
    duration: 1,
    active: true,
  },
  {
    course: 'Blood Borne Pathogens',
    duration: 1,
    active: true,
  },
  {
    course: 'Body Mechanics',
    duration: 2,
    active: true,
  },
  {
    course: 'Body Temperature Simulation',
    duration: 0.5,
    active: true,
  },
  {
    course: 'Body Temperature Simulation Debriefing',
    duration: 0.5,
    active: true,
  },
  {
    course: 'Boundaries and Self-Care Skills',
    duration: 2,
    active: true,
  },
  {
    course: 'Care Aide Fundamentals - Caring4Cal',
    duration: 15,
    active: true,
  },
  {
    course: 'Care Team Dynamics',
    duration: 1,
    active: true,
  },
  {
    course: 'Caregiver Development program',
    duration: 20,
    active: false,
  },
  {
    course: 'Caregiver Development Program 1',
    duration: 6,
    active: true,
  },
  {
    course: 'Caregiver Development Program 2',
    duration: 15,
    active: true,
  },
  {
    course: 'Caregiver Relaxation Guide',
    duration: 0.5,
    active: true,
  },
  {
    course: 'Caregivers',
    duration: 1,
    active: true,
  },
  {
    course: 'Caregiving Cornerstone',
    duration: 4,
    active: true,
  },
  {
    course: 'Caring for the Caregiver: How Thoughts Can Affect Our Emotions',
    duration: 0.5,
    active: true,
  },
  {
    course: 'Caring for the Caregiver: Managing Caregiver Stress',
    duration: 0.5,
    active: true,
  },
  {
    course: 'Caring with Confidence: Essential Skills for Safety and Observation',
    duration: 15,
    active: true,
  },
  {
    course: 'Case management technology for CHWs',
    duration: 8,
    active: true,
  },
  {
    course: 'Catheter Care & Urine Output Simulation',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Catheter Care & Urine Output Simulation Debriefing',
    duration: 1.5,
    active: true,
  },
  {
    course: 'CDPH Approved In-service Modules- Caring4Cal',
    duration: 15,
    active: true,
  },
  {
    course: 'Certified Home Health Aide (CHHA) By LeadingAge',
    duration: 40,
    active: true,
  },
  {
    course: 'Certified Nurse Assistant (CNA) by Leading Age',
    duration: 160,
    active: true,
  },
  {
    course: 'Cheer Homecare - Compliance & Caregiving Part 1 (Caring4Cal) (5.5 hrs) (Nevvon)',
    duration: 5.5,
    active: true,
  },
  {
    course: 'Cheer Homecare - Compliance & Caregiving Part 2 (Caring4Cal) (9.5 hrs) (Nevvon)',
    duration: 9.5,
    active: true,
  },
  {
    course: 'CNA/HHA CEUs',
    duration: 72,
    active: true,
  },
  {
    course: 'Colostomy Care Simulation',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Common auto immune diseases',
    duration: 1,
    active: true,
  },
  {
    course: 'Common Conditions in HCBS- Caring4Cal',
    duration: 15,
    active: true,
  },
  {
    course: 'Common Conditions in HCBS - Caring4Cal At Home Nursing Care (Nevvon)',
    duration: 15,
    active: true,
  },
  {
    course: 'Common Skin Conditions from A - Z',
    duration: 1,
    active: true,
  },
  {
    course: 'Communication and Engagement',
    duration: 2,
    active: true,
  },
  {
    course: 'Community Health in Context',
    duration: 2,
    active: true,
  },
  {
    course: 'Community Health Worker - 32 hour',
    duration: 32,
    active: true,
  },
  {
    course: 'Community Health Worker Billing in California',
    duration: 1,
    active: true,
  },
  {
    course: 'Community Health Worker Care Coordination Process',
    duration: 3,
    active: true,
  },
  {
    course: 'Community Health Worker Training Lite',
    duration: 16,
    active: true,
  },
  {
    course: 'Community Health Workers’ Code of Ethics',
    duration: 1,
    active: true,
  },
  {
    course: 'Compassionate Communication',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Compassionate Meditation for Caregivers',
    duration: 1,
    active: true,
  },
  {
    course: 'Compliance & Caregiving- Caring4Cal',
    duration: 15,
    active: true,
  },
  {
    course: 'Comprehensive Nutrition and Meal Planning',
    duration: 2,
    active: true,
  },
  {
    course: 'Conflict Resolution Skills',
    duration: 2,
    active: true,
  },
  {
    course: 'Cooking for your clients',
    duration: 1,
    active: true,
  },
  {
    course: 'CPR/Basic Life Support',
    duration: 5,
    active: true,
  },
  {
    course: 'Creating Dementia Capable Health Systems',
    duration: 3,
    active: true,
  },
  {
    course: 'Creating Lasting Relationships for Community Health Improvement',
    duration: 2.5,
    active: true,
  },
  {
    course: 'Crisis Intervention Skills',
    duration: 2,
    active: true,
  },
  {
    course: 'Crisis Management Mastery',
    duration: 2,
    active: true,
  },
  {
    course: 'Crisis Prevention and Early Intervention Pt. 1',
    duration: 2,
    active: true,
  },
  {
    course: 'Crisis Prevention & Intervention Mastery Pt. 2',
    duration: 2,
    active: true,
  },
  {
    course: 'Crisis Prevention & Intervention Part 1',
    duration: 3,
    active: true,
  },
  {
    course: 'Crisis Prevention & Intervention Part 2',
    duration: 3,
    active: true,
  },
  {
    course: 'Cross-Cultural Communications',
    duration: 2.5,
    active: true,
  },
  {
    course: 'Cultural Care Competence',
    duration: 2,
    active: true,
  },
  {
    course: 'Cultural Humility',
    duration: 3,
    active: true,
  },
  {
    course: 'Dealing with family members',
    duration: 1,
    active: true,
  },
  {
    course: 'Dementia & the Power of Music',
    duration: 0.5,
    active: true,
  },
  {
    course: 'Dementia Care Strategies',
    duration: 2,
    active: true,
  },
  {
    course: 'Denture Care Simulation',
    duration: 1,
    active: true,
  },
  {
    course: 'Denture Care Simulation Debriefing',
    duration: 0.5,
    active: true,
  },
  {
    course: 'Developmental Disabilities Care',
    duration: 2,
    active: true,
  },
  {
    course: 'Disability Care Principles',
    duration: 2,
    active: true,
  },
  {
    course: 'Disaster planning',
    duration: 1,
    active: true,
  },
  {
    course: 'Diversity and Cultural Care',
    duration: 2,
    active: true,
  },
  {
    course: 'Documentation Excellence',
    duration: 2,
    active: true,
  },
  {
    course: "Down Syndrome and Alzheimer's: The Latest Research",
    duration: 1,
    active: true,
  },
  {
    course: 'E2C-Certified Nurse Assistant and Certified Home Health Aide Training',
    duration: 220,
    active: true,
  },
  {
    course: 'Early Detection in Adults with Intellectual and Developmental Disabilities',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Educating Communities',
    duration: 2,
    active: true,
  },
  {
    course: 'Education Skills',
    duration: 2,
    active: true,
  },
  {
    course: 'Effective Communication Techniques for CHW/P',
    duration: 6,
    active: true,
  },
  {
    course: 'Emergency Response & Safety Protocols',
    duration: 2,
    active: true,
  },
  {
    course: 'Emotionally Present: Support and Self-Care',
    duration: 2,
    active: true,
  },
  {
    course: 'End of Life/ Grief Care',
    duration: 6,
    active: true,
  },
  {
    course: 'End-of-Life Care & Grief Support',
    duration: 2,
    active: true,
  },
  {
    course: 'End-of-Life Care and Grieving Support',
    duration: 2,
    active: true,
  },
  {
    course: 'Enema Simulation',
    duration: 1,
    active: true,
  },
  {
    course: 'Ethical dilemmas in health care',
    duration: 1,
    active: true,
  },
  {
    course: 'Ethical Practices and Legal Compliance',
    duration: 2,
    active: true,
  },
  {
    course: 'Feeding Assistance Simulation',
    duration: 1,
    active: true,
  },
  {
    course: 'Feeding Assistance Simulation Debriefing',
    duration: 0.5,
    active: true,
  },
  {
    course: 'Feeding your client',
    duration: 1,
    active: true,
  },
  {
    course: 'Field Work and Home Visits',
    duration: 2,
    active: true,
  },
  {
    course: 'Fire prevention and safety',
    duration: 1,
    active: true,
  },
  {
    course: 'First Aide',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Foot Care Simulation',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Foot Care Simulation Debriefing',
    duration: 0.5,
    active: true,
  },
  {
    course:
      'Foundational Skills: Communication and Relationship-Building Skills, Motivational Interviewing, Goal Setting',
    duration: 6,
    active: true,
  },
  {
    course: 'Foundations of Professional CHW Practice',
    duration: 2,
    active: true,
  },
  {
    course: 'Gerontological Care Excellence',
    duration: 2,
    active: true,
  },
  {
    course: 'Gerontology and Dementia Care',
    duration: 2,
    active: true,
  },
  {
    course: 'Gerontology Foundations',
    duration: 2,
    active: true,
  },
  {
    course: 'Glenner GRACE',
    duration: 1,
    active: true,
  },
  {
    course: 'Glucometer Simulation',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Grief and Resilience',
    duration: 2,
    active: true,
  },
  {
    course: 'Hand Sanitizer Simulation',
    duration: 0.5,
    active: true,
  },
  {
    course: 'Hand washing',
    duration: 1,
    active: true,
  },
  {
    course: 'Handling incontinence of the bowel and bladder',
    duration: 1,
    active: true,
  },
  {
    course: 'Handwashing Simulation',
    duration: 0.5,
    active: true,
  },
  {
    course: 'Handwashing Simulation Debriefing',
    duration: 0.5,
    active: true,
  },
  {
    course: 'HCA Compliance (Part 3) - Caring4Cal (Nevvon)',
    duration: 15,
    active: true,
  },
  {
    course: 'HCA Compliance (Part 4) - Caring4Cal (Nevvon)',
    duration: 15,
    active: true,
  },
  {
    course: 'Health and Chronic Conditions',
    duration: 2,
    active: true,
  },
  {
    course: 'Health Cornerstone',
    duration: 4,
    active: true,
  },
  {
    course: 'Healthcare is Re-entry',
    duration: 3,
    active: true,
  },
  {
    course: 'Healthy Aging Support',
    duration: 2,
    active: true,
  },
  {
    course: 'Helping CHWs find their purpose',
    duration: 1,
    active: true,
  },
  {
    course: 'Helping Community Health Workers Find Their Purpose',
    duration: 1,
    active: true,
  },
  {
    course: 'Helping with instrumental activities of daily living',
    duration: 1,
    active: true,
  },
  {
    course: 'Holistic Approach to Care and Advance Care Planning',
    duration: 2.5,
    active: true,
  },
  {
    course: 'Home CARE Essentials',
    duration: 15,
    active: true,
  },
  {
    course: 'Home Health Aide by Angeles Institute',
    duration: 40,
    active: true,
  },
  {
    course: 'Home Health Aide by Best American Healthcare University',
    duration: 120,
    active: true,
  },
  {
    course: 'Home Health Aide by Fox Home Health Vocational Training(120 Hours)',
    duration: 120,
    active: true,
  },
  {
    course: 'Home Health Aide by Northern California Nursing Academy',
    duration: 40,
    active: true,
  },
  {
    course: 'Home Health Best Practices',
    duration: 2,
    active: true,
  },
  {
    course: 'Home Health Care Nursing Success',
    duration: 15,
    active: true,
  },
  {
    course: 'Home-Based Services Excellence',
    duration: 2,
    active: true,
  },
  {
    course: 'Home-Based Services Mastery',
    duration: 2,
    active: true,
  },
  {
    course: 'Housekeeping & Cleanliness Protocols',
    duration: 2,
    active: true,
  },
  {
    course: 'How to Navigate End-of-Life Care',
    duration: 15,
    active: true,
  },
  {
    course: 'Inclusive Team Building',
    duration: 2,
    active: true,
  },
  {
    course: 'Infection Control and Cleanliness Standards',
    duration: 2,
    active: true,
  },
  {
    course: 'Infection Control and Safety',
    duration: 2,
    active: true,
  },
  {
    course: 'Infection Control in the home',
    duration: 1,
    active: true,
  },
  {
    course: 'Infection Control Update',
    duration: 1,
    active: true,
  },
  {
    course: 'InPerson CNA',
    duration: 160,
    active: true,
  },
  {
    course: 'Insurance, Benefits and Resources',
    duration: 2,
    active: true,
  },
  {
    course: 'Introduction to Caregiving for Older Adults',
    duration: 15,
    active: true,
  },
  {
    course: 'Introduction to Dementia Care',
    duration: 2,
    active: true,
  },
  {
    course: 'Introduction to Healthcare',
    duration: 15,
    active: true,
  },
  {
    course: 'Lactation Specialist',
    duration: 32,
    active: true,
  },
  {
    course: 'Laughter Yoga-an Antidote for Caregiver Burnout',
    duration: 1,
    active: true,
  },
  {
    course: 'Leadership Growth for Community Health Workers',
    duration: 1,
    active: true,
  },
  {
    course: 'Legal & Ethical Considerations in Care',
    duration: 2,
    active: true,
  },
  {
    course: 'Legal and Ethical Considerations',
    duration: 2,
    active: true,
  },
  {
    course: 'LGBTQ+ 101 Training',
    duration: 1,
    active: true,
  },
  {
    course: 'LGBTQ+ Mental Health Training',
    duration: 1,
    active: true,
  },
  {
    course: 'LLM/Caring Corner (1) - (Nevvon)',
    duration: 15,
    active: true,
  },
  {
    course: 'LLM/Caring Corner (2) - (Nevvon)',
    duration: 15,
    active: true,
  },
  {
    course: 'Maintaining Clean and Healthy Environment',
    duration: 2,
    active: true,
  },
  {
    course: 'Maintaining Confidentiality',
    duration: 1,
    active: true,
  },
  {
    course: 'Maintaining your clients dignity',
    duration: 1,
    active: true,
  },
  {
    course: 'Managing Stress and Avoiding Burnout',
    duration: 2,
    active: true,
  },
  {
    course: 'Managing Stress as a Caregiver',
    duration: 6,
    active: true,
  },
  {
    course: 'Mastering Motivational Interviewing',
    duration: 2,
    active: true,
  },
  {
    course: 'Medication Management',
    duration: 1,
    active: true,
  },
  {
    course: 'Memory Loss',
    duration: 1,
    active: true,
  },
  {
    course: 'Mental Health & Pediatrics- Caring4Cal',
    duration: 15,
    active: true,
  },
  {
    course: 'Mental Health and Stress Management',
    duration: 2,
    active: true,
  },
  {
    course: 'Mental Health and Substance Use',
    duration: 2,
    active: true,
  },
  {
    course: 'Mental Health First Aid',
    duration: 7,
    active: true,
  },
  {
    course: 'Mental Health for CHW: Avoiding Burnout',
    duration: 2,
    active: true,
  },
  {
    course: 'Mental Health Stigma Reduction',
    duration: 2,
    active: true,
  },
  {
    course: 'Mobility & Conditions Affecting Mobility- Caring4Cal',
    duration: 15,
    active: true,
  },
  {
    course: 'Mobility & Conditions Affecting Mobility - Caring4Cal At Home Nursing Care (Nevvon)',
    duration: 15,
    active: true,
  },
  {
    course: 'Mobility Assistance & Safety Tools',
    duration: 1,
    active: true,
  },
  {
    course: 'Module 1: Introduction to Community Health Workers',
    duration: 9,
    active: true,
  },
  {
    course: 'Module 2: Community Health Workers Background Knowledge',
    duration: 14,
    active: true,
  },
  {
    course: 'Module 3: Community Health Worker Foundational Skills',
    duration: 13,
    active: true,
  },
  {
    course: 'Module 4: Community Health Worker Best Practices',
    duration: 7,
    active: true,
  },
  {
    course: 'Mouth Care Simulation',
    duration: 1,
    active: true,
  },
  {
    course: 'Mouth Care Simulation Debriefing',
    duration: 0.5,
    active: true,
  },
  {
    course: 'Multicultural Care Practices',
    duration: 2,
    active: true,
  },
  {
    course: 'Naloxone Nasal Spray Simulation',
    duration: 1,
    active: true,
  },
  {
    course: 'Normal Aging Process',
    duration: 1,
    active: true,
  },
  {
    course: 'Nurse Assistant Training Program',
    duration: 160,
    active: true,
  },
  {
    course: 'Nurse Assistant Training Program (CNA)',
    duration: 176,
    active: true,
  },
  {
    course: 'Nutrition & Meal Preparation Fundamentals',
    duration: 2,
    active: true,
  },
  {
    course: 'Nutritional Health Practices',
    duration: 2,
    active: true,
  },
  {
    course: 'Online CNA',
    duration: 160,
    active: true,
  },
  {
    course: 'Online HHA',
    duration: 40,
    active: true,
  },
  {
    course: 'Outreach',
    duration: 8,
    active: true,
  },
  {
    course: 'Overview of Nutrition and Food Preparation',
    duration: 2,
    active: true,
  },
  {
    course: 'Overview of Skin Care and Wound Prevention',
    duration: 2,
    active: true,
  },
  {
    course: 'Overview of Transfers and Mobility Equipment',
    duration: 2,
    active: true,
  },
  {
    course: 'Oxygen Safety for Caregivers',
    duration: 1,
    active: true,
  },
  {
    course: 'Part A Compliance & Caregiving - Caring4Cal Training (SHS Reseda) (5.5 hrs) (Nevvon)',
    duration: 5.5,
    active: true,
  },
  {
    course: 'Part B Compliance & Caregiving - Caring4Cal Training (SHS Reseda) (9.5 hrs) (Nevvon)',
    duration: 9.5,
    active: true,
  },
  {
    course:
      'Part C Mobility & Conditions Affecting Mobility - Caring4Cal Training (SHS Reseda) (Nevvon)',
    duration: 15,
    active: true,
  },
  {
    course: 'Patient Care Skill',
    duration: 2,
    active: true,
  },
  {
    course: 'Performing Mouth Care',
    duration: 1,
    active: true,
  },
  {
    course: 'Performing Safe Transfers',
    duration: 1,
    active: true,
  },
  {
    course: 'Perineal Care Simulation',
    duration: 1,
    active: true,
  },
  {
    course: 'Perineal Care Simulation Debriefing',
    duration: 0.5,
    active: true,
  },
  {
    course: 'Person-Centered Practices',
    duration: 2,
    active: true,
  },
  {
    course: "Preparing CNA students for Dementia's Complexity",
    duration: 1,
    active: true,
  },
  {
    course: 'Preventing Senior Abuse',
    duration: 2,
    active: true,
  },
  {
    course: 'Privacy and HIPAA',
    duration: 4,
    active: true,
  },
  {
    course: 'Problem-Solving & Innovation in Home Settings',
    duration: 2,
    active: true,
  },
  {
    course: 'Problem-Solving and Decision Making',
    duration: 2,
    active: true,
  },
  {
    course: 'Professional Communication & Reporting',
    duration: 2,
    active: true,
  },
  {
    course: 'Programa Intermedia de Formación para Cuidadors en Español: 15 Horas',
    duration: 15,
    active: true,
  },
  {
    course: 'Programa Principiante de Formación para Cuidadors en Español: 15 Horas',
    duration: 15,
    active: true,
  },
  {
    course: 'Quest Nursing CNA Training Program',
    duration: 160,
    active: true,
  },
  {
    course: 'Quest Nursing HHA Training Program',
    duration: 40,
    active: true,
  },
  {
    course: 'Re-entry Support',
    duration: 1,
    active: true,
  },
  {
    course: 'Recognizing and reporting abnormal observations',
    duration: 1,
    active: true,
  },
  {
    course: 'Recognizing Fire & Medical Emergencies',
    duration: 2,
    active: true,
  },
  {
    course: 'Rectal Suppository Simulation',
    duration: 1,
    active: true,
  },
  {
    course: 'Rehabilitation and Restorative Care Mastery',
    duration: 2,
    active: true,
  },
  {
    course: 'Respiratory Rate Simulation',
    duration: 1,
    active: true,
  },
  {
    course: 'Respiratory Rate Simulation Debriefing',
    duration: 0.5,
    active: true,
  },
  {
    course: 'Restorative Nursing Assistant',
    duration: 16,
    active: true,
  },
  {
    course: 'Restorative Nursing Program (RNA)',
    duration: 16,
    active: true,
  },
  {
    course: 'RCFE - Caring4Cal - Program 1 (Nevvon)',
    duration: 15,
    active: true,
  },
  {
    course: 'RCFE - Caring4Cal - Program 2 (Nevvon)',
    duration: 15,
    active: true,
  },
  {
    course: 'RN/LVN CEUs',
    duration: 30,
    active: true,
  },
  {
    course: 'Roles and boundaries of a home based CHW/P',
    duration: 2.5,
    active: true,
  },
  {
    course: 'Safety First: Physical Precautions',
    duration: 2,
    active: true,
  },
  {
    course: 'Safety Precautions and Fall Prevention',
    duration: 2,
    active: true,
  },
  {
    course: 'Safety, Risk and Privacy',
    duration: 2,
    active: true,
  },
  {
    course: 'Self Care',
    duration: 0.5,
    active: true,
  },
  {
    course: 'Self-Care for Community Health Workers',
    duration: 2,
    active: true,
  },
  {
    course: 'Self-Care: Healers Need Healing Too',
    duration: 3,
    active: true,
  },
  {
    course: 'Seniors and Depression Management',
    duration: 2,
    active: true,
  },
  {
    course: 'Shifting Your Mindset',
    duration: 0.5,
    active: true,
  },
  {
    course: 'Side Positioning Simulation',
    duration: 1,
    active: true,
  },
  {
    course: 'Side Positioning Simulation Debriefing',
    duration: 0.5,
    active: true,
  },
  {
    course: 'Social Cornerstone',
    duration: 4,
    active: true,
  },
  {
    course: 'Social Determinants of Health',
    duration: 2,
    active: true,
  },
  {
    course: 'Social Risks and Social Needs',
    duration: 2,
    active: true,
  },
  {
    course: 'Solutions-Focused Home Health Practices',
    duration: 2,
    active: true,
  },
  {
    course: 'Special Communication Needs',
    duration: 1,
    active: true,
  },
  {
    course: 'Spiritual Cornerstone',
    duration: 4,
    active: true,
  },
  {
    course: 'Strengths & Solutions in Community Care',
    duration: 2,
    active: true,
  },
  {
    course: 'Strengths-Based Home Intervention',
    duration: 2,
    active: true,
  },
  {
    course: 'Stress and Trauma',
    duration: 2,
    active: true,
  },
  {
    course: 'Stress in the Mind and Body',
    duration: 0.5,
    active: true,
  },
  {
    course: 'Stress Mastery in End-of-Life Care',
    duration: 2,
    active: true,
  },
  {
    course: 'Supporting and guiding individuals through dementia related behaviors.',
    duration: 1,
    active: true,
  },
  {
    course: 'Tai Chi: Holistic Self-Care for Caregivers',
    duration: 1,
    active: true,
  },
  {
    course:
      'Talking About Dementia in Individuals with Intellectual and Developmental Disabilities',
    duration: 1,
    active: true,
  },
  {
    course: 'Team Building and Collaborative Work',
    duration: 2,
    active: true,
  },
  {
    course: 'TED Hose & Leg Elevation Simulation',
    duration: 1,
    active: true,
  },
  {
    course: 'TED Hose & Leg Elevation Simulation Debriefing',
    duration: 0.5,
    active: true,
  },
  {
    course: 'Teepa Snow Dementia Training for In-Home Care',
    duration: 15,
    active: true,
  },
  {
    course: 'Teepa Snow Positive Approach to Care (PAC) training',
    duration: 2,
    active: true,
  },
  {
    course: 'Telehealth',
    duration: 1,
    active: true,
  },
  {
    course: 'The Burden of Social Circumstances',
    duration: 2.5,
    active: true,
  },
  {
    course: 'The Care planning Process',
    duration: 1,
    active: true,
  },
  {
    course: 'The caring qualities of a CNA',
    duration: 1,
    active: true,
  },
  {
    course: 'The National LGBTQ+ Curriculum: Part I',
    duration: 5,
    active: true,
  },
  {
    course: 'Transformative Adult Education Practices',
    duration: 6,
    active: true,
  },
  {
    course: 'Transgender Health Equity',
    duration: 3,
    active: true,
  },
  {
    course: 'Understanding & Responding to Dementia-Related Behavior',
    duration: 3,
    active: true,
  },
  {
    course: 'Understanding Abuse',
    duration: 1,
    active: true,
  },
  {
    course: 'Understanding and Navigating Cultural Care',
    duration: 2,
    active: true,
  },
  {
    course: 'Understanding basic human needs',
    duration: 1,
    active: true,
  },
  {
    course: 'Understanding Dementia & Alzheimer’s',
    duration: 2,
    active: true,
  },
  {
    course:
      'Understanding Dementia in Adults with Intellectual and Developmental Disabilities~ Including Autism and Down Syndrome Part 1',
    duration: 1.5,
    active: true,
  },
  {
    course:
      'Understanding Dementia in Adults with Intellectual and Developmental Disabilities~ Including Autism and Down Syndrome Part 2',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Understanding Disabilities',
    duration: 2,
    active: true,
  },
  {
    course: 'Understanding Ethics, Prevention and Patient Safety',
    duration: 15,
    active: true,
  },
  {
    course: 'Understanding Hospice',
    duration: 1,
    active: true,
  },
  {
    course: 'Understanding Physical Disabilities',
    duration: 2,
    active: true,
  },
  {
    course: 'Understanding the role of a CHW/Promoter in the Community',
    duration: 6,
    active: true,
  },
  {
    course:
      'Understanding Treatable Conditions that Mimic ADRD in Intellectual and Developmental Disabilities Population',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Using Assistive Devices',
    duration: 1,
    active: true,
  },
  {
    course: 'Virtual Dementia Tour',
    duration: 2.5,
    active: true,
  },
  {
    course: 'Vital Signs',
    duration: 2,
    active: true,
  },
  {
    course: 'Vocational Nursing by Angeles Institute',
    duration: 1610,
    active: true,
  },
  {
    course: 'Vocational Nursing Program (LVN)',
    duration: 1636,
    active: true,
  },
  {
    course: 'What is a Care Navigator and Foundational Skills',
    duration: 2.5,
    active: true,
  },
  {
    course: 'Who are Community Health Workers?',
    duration: 1,
    active: true,
  },
  {
    course: 'Workforce Readiness for Promoters/CHWs',
    duration: 16,
    active: true,
  },
  {
    course: 'Working with clients with intellectual disabilities',
    duration: 1,
    active: true,
  },
  {
    course:
      'Working with Health Care Providers - Giving a Voice and Supporting Adults with Intellectual and Developmental Disabilities (IDD)',
    duration: 1.5,
    active: true,
  },
];

export const VERIFICATION_FORM_LINK =
  'https://39905001.fs1.hubspotusercontent-na1.net/hubfs/39905001/Caring4Cal%20Employment%20Verification%20Form%20(EVF)%20-%20Editable.pdf';

const courses: BaseDropdownItem[] = COURSES?.map(({ course, active }) => ({
  label: course,
  value: course,
  disabled: !active,
}));

export const COMMON_PAGES: { [key: string]: IntroPage } = {
  applicationProcess: {
    key: 'application-process',
    layout: 'steps',
    title: 'About the application process',
    copy: 'Here are some things to know before you start',
    steps: [
      {
        title: 'It takes up to 20 minutes to complete',
        icon: 'time',
        description:
          'You can expect to spend 20 minutes or less to complete your application if you have all your materials.',
      },
      {
        title: 'Your progress will be saved as you go',
        icon: 'checkCircleOutline',
        description:
          'You can start your application and finish it later. If you need to come back to complete your application, you can start where you left off.',
      },
      {
        title: 'Enter necessary information to process your request and get paid',
        icon: 'infoOutline',
        description: 'We recommend completing the application in a safe and private space.',
      },
      {
        title: 'Your data is secure',
        icon: 'gppGoodOutlined',
        description:
          'We will safely store your data to help you apply to future applications faster, and we will not share your data with third parties without your consent.',
      },
      {
        title: 'Check your inbox',
        icon: 'mail',
        description:
          'We will let you know that we have received your completed application. We’ll get back to you if we need any more information.',
      },
    ],
  },
  termsOfServiceAndPrivacyPolicy: {
    key: 'tos-and-pp',
    layout: 'default',
    title: 'Terms of Service and Privacy Policy',
    body: `
Cell-Ed administers the Caring4Cal incentive program.
      
By tapping CONTINUE, you agree to Cell-Ed's [Terms of Service](https://www.cell-ed.com/terms-of-service/) and [Privacy Policy](https://www.cell-ed.com/privacy-policy).`,
  },
};

export const COMMON_QUESTIONS: {
  [key in
    | CommonQuestionKeys.ADDRESS
    | CommonQuestionKeys.MAILING_ADDRESS
    | 'firstTimeApplying'
    | 'incentiveLevels'
    | 'courseCompletedL1'
    | 'courseCompletedL2'
    | 'employers']: ApplicationQuestion;
} = {
  firstTimeApplying: {
    key: 'firstTimeApplying',
    copy: { title: 'Is this your first time applying for incentives?' },
    fields: [
      {
        type: FieldType.RadioList,
        key: 'firstTimeApplying',
        options: YesNoOptions,
      },
    ],
  },
  incentiveLevels: {
    key: 'incentiveLevels',
    copy: {
      title: 'What Incentive Level are you applying for?',
      intro:
        'Not sure which level to choose? We can help. Review the Caring4Cal incentive levels [here](https://www.caring4cal.org/en/home-care-provider-payments) or give us a call at (844) 425-1516.',
    },
    fields: [
      {
        type: FieldType.RadioList,
        key: 'incentiveLevel',
        options: [
          {
            value: 'level1',
            label: 'I am applying for Level 1',
          },
          {
            value: 'level2',
            label: 'I am applying for Level 2',
          },
          {
            value: 'level3',
            label: 'I am applying for Level 3',
          },
        ],
      },
    ],
  },
  courseCompletedL1: {
    key: 'courseCompletedL1',
    copy: {
      title: 'Please select the Caring4Cal courses you completed.',
      intro: `
Add proof of course completion for each course you completed. You must have completed 15 hours to be approved.

PLEASE NOTE: If you have taken an additional 15 hours of coursework, come back and apply for your $750 incentive using Level 2 - Leap Forward. You cannot apply for both incentive levels together in Level 1.`,
    },
    fields: [
      {
        type: FieldType.Complex,
        key: 'courseCompletedL1.courses',
        copy: 'Course',
        subFields: [
          {
            type: FieldType.Dropdown,
            copy: 'Course',
            key: 'name',
            options: courses,
            props: { searchable: true },
          },
          {
            type: FieldType.Calculated,
            key: 'creditHours',
            display: { copy: 'Credit Hours' },
            formula: {
              type: ExpressionType.Condition,
              conditions: COURSES.map(({ course, duration }) => ({
                if: eq('name', course),
                then: literal(duration),
              })),
              else: literal(0),
            },
          },
          {
            type: FieldType.Document,
            key: 'courseProof',
          },
        ],
      },
      {
        type: FieldType.Calculated,
        display: {
          copy: 'Total Credit Hours',
          validation: {
            required: true,
            rules: [
              {
                rule: gte('courseCompletedL1.totalCreditHours', 15),
                message:
                  'You will need to complete at least 15 hours of courses before you’re able to apply for incentives',
              },
            ],
          },
        },
        key: 'courseCompletedL1.totalCreditHours',
        formula: sum('courseCompletedL1.courses', 'creditHours'),
      },
    ],
  },
  courseCompletedL2: {
    key: 'courseCompletedL2',
    copy: {
      title: 'Please select the Caring4Cal courses you completed.',
      intro: `
Add proof of course completion for each course you completed. You must have completed 15 hours to be approved.
      
PLEASE NOTE: If you have taken an additional 15 hours of coursework, come back and apply for your $750 incentive using Level 2 - Leap Forward. You cannot apply for both incentive levels together in Level 1.`,
    },
    fields: [
      {
        type: FieldType.Complex,
        key: 'courseCompletedL2.courses',
        copy: 'Course',
        subFields: [
          {
            type: FieldType.Dropdown,
            copy: 'Course',
            key: 'name',
            options: courses,
            props: { searchable: true },
          },
          {
            type: FieldType.Calculated,
            key: 'creditHours',
            display: { copy: 'Credit Hours' },
            formula: {
              type: ExpressionType.Condition,
              conditions: COURSES.map(({ course, duration }) => ({
                if: eq('name', course),
                then: literal(duration),
              })),
              else: literal(0),
            },
          },
          {
            type: FieldType.Document,
            key: 'courseProof',
          },
        ],
      },
      {
        type: FieldType.Calculated,
        display: {
          copy: 'Total Credit Hours',
          validation: {
            required: true,
            rules: [
              {
                rule: gte('courseCompletedL2.totalCreditHours', 15),
                message:
                  'You will need to complete at least 15 hours of courses before you’re able to apply for incentives',
              },
            ],
          },
        },
        key: 'courseCompletedL2.totalCreditHours',
        formula: sum('courseCompletedL2.courses', 'creditHours'),
      },
    ],
  },
  [CommonQuestionKeys.ADDRESS]: mergeObjects(
    [
      STANDARD_COMPONENTS.definitions.questions[CommonQuestionKeys.ADDRESS],
      {
        copy: {
          title: 'What is your home address?',
          intro: 'You must live in California to participate in Caring4Cal.',
        },
        fields: [
          {
            filter: { state: 'CA' },
          },
        ],
      },
    ],
    'merge',
  ) as ApplicationQuestion,
  [CommonQuestionKeys.MAILING_ADDRESS]: mergeObjects(
    [
      STANDARD_COMPONENTS.definitions.questions[CommonQuestionKeys.MAILING_ADDRESS],
      {
        copy: {
          title: 'What is your mailing address?',
          intro:
            'Your incentive check will be mailed to this address if your application is approved and you choose ‘check’ as your payment option.',
        },
        fields: [
          {
            filter: { state: 'CA' },
          },
        ],
      },
    ],
    'merge',
  ) as ApplicationQuestion,
  employers: {
    key: 'employers',
    copy: {
      title: 'Please list all of your current employers',
    },
    fields: [
      {
        type: FieldType.Complex,
        key: 'employers',
        copy: 'Employer',
        subFields: [
          {
            type: FieldType.Text,
            inputType: TextInputType.Text,
            key: 'name',
            copy: 'Name',
          },
          {
            type: FieldType.Text,
            inputType: TextInputType.Text,
            key: CommonQuestionKeys.ZIP_CODE,
            copy: 'Zip Code',
          },
        ],
      },
    ],
  },
};

export const COMMON_SECTIONS: { [key: string]: ApplicationSection } = {
  paymentInfoSection: {
    key: 'paymentInfoSection',
    name: 'Payment Information',
    overview: {
      title: 'Payment Information',
      description:
        'In this section you will indicate how you would like to receive payment if your application is approved.',
    },
    questionGroups: [
      {
        key: 'paymentInfoSection',
        name: 'Payment Information',
        questions: [
          mergeObjects(
            [
              STANDARD_COMPONENTS.definitions.questions.preferredPaymentMethod,
              {
                copy: {
                  title: 'How would you like to receive your payments?',
                },
                fields: [
                  {
                    type: FieldType.RadioList,
                    key: CommonQuestionKeys.PREFERRED_PAYMENT_METHOD,
                    options: [
                      {
                        label: 'ACH Direct Deposit',
                        description:
                          'When choosing this payment method, you will proceed to a secure page to enter your bank account and routing information so that we can issue payments directly to your bank account.',
                        value: PaymentMethod.DirectDeposit,
                      },
                      {
                        label: 'Paper Check',
                        description:
                          'We will mail you a physical check that will arrive in 7-10 days after your payment has been initiated.',
                        value: PaymentMethod.Check,
                      },
                    ],
                  },
                ],
              } as ApplicationQuestion,
            ],
            'overwrite',
          ),
          {
            key: 'bankAccount',
            copy: { title: 'Bank Account Details' },
            fields: [],
            dynamicLogic: eq('preferredPaymentMethod', PaymentMethod.DirectDeposit),
          },
        ],
      },
    ],
  },
  review: mergeObjects(
    [
      STANDARD_COMPONENTS.definitions.sections[SpecialSectionKeys.Review],
      {
        questionGroups: [
          {
            key: 'submission.assistance',
            name: 'Application Assistance',
            questions: [
              {
                ...STANDARD_COMPONENTS.definitions.questions[
                  CommonQuestionKeys.APPLICATION_ASSISTANCE_HELPER
                ],
                copy: {
                  title: 'Did someone help you fill out this application?',
                  intro:
                    'Please provide the following information about the person who helped you complete your registration. If nobody helped you, click SKIP.',
                },
              },
            ],
          },
          {
            key: CommonQuestionKeys.AFFIRMATION,
            name: 'Affirmation',
            questions: [
              {
                key: CommonQuestionKeys.AFFIRMATION,
                copy: {
                  title: 'Before submitting the application, please confirm this statement:',
                  intro: 'Please review and confirm the statement by selecting the checkbox below.',
                },
                fields: [
                  {
                    type: FieldType.Checkbox,
                    key: CommonQuestionKeys.AFFIRMATION,
                    copy: 'I, {APPLICANT_NAME}, certify under penalty of law, based on information and belief formed after reasonable inquiry, the statements and information contained in these documents are true, accurate and complete.',
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
    'merge',
  ) as ApplicationSection,
};

export const COMMON_OVERRIDES: ConfigOverrides = {
  submission: {
    title: 'What happens next?',
    bullets: [
      {
        key: 'review',
        title: 'Application Review',
        icon: 'description',
        description:
          'While we look at your application, we might send you an email to ask for more information or documents.',
      },
      {
        key: 'decision',
        title: 'Application decision',
        icon: 'mail',
        description:
          'We will notify you when your Caring4Cal incentive payment has been processed.',
      },
    ],
  },
};
